import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import { jsx, jsxs } from 'react/jsx-runtime';
import { useEffect, useRef } from 'react';
import { VerifiedStoreIcon, ScriptPrint } from '@ads-placements-frontend/commons';
import Card, { CardContent } from '@andes/card';
import CarouselFree, { CarouselFreeSlide } from '@andes/carousel-free';
import { RecommendationsCardHorizontalTitleFirst } from '@recommendations-fe/card';
import Typography from '@andes/typography';
import Image from 'frontend-image';
const Carousel = props => {
  const {
    items,
    IconFactory,
    hasOverlay
  } = props;
  return jsx("div", {
    className: "carousel",
    children: jsx(CarouselFree, {
      "aria-label": "Brand carousel",
      children: items.map(item => jsx(CarouselFreeSlide, {
        spacing: 12,
        children: jsx(RecommendationsCardHorizontalTitleFirst, _objectSpread({
          IconFactory: IconFactory,
          hasOverlay: hasOverlay
        }, item))
      }, item.id))
    })
  });
};
const namespace$2 = 'hero-top';
const HeroTop = props => {
  var _texts$alt_logo;
  const {
    items,
    lowEnd
  } = props;
  const [{
    content: {
      images,
      texts
    },
    event_tracking: {
      click
    }
  }] = items;
  const [url] = click;
  return jsx("a", {
    href: url.url,
    children: jsxs("div", {
      className: `${namespace$2}`,
      children: [jsx(Image, {
        preload: true,
        src: images.primary_logo,
        alt: (_texts$alt_logo = texts.alt_logo) !== null && _texts$alt_logo !== void 0 ? _texts$alt_logo : '',
        lowEnd: lowEnd,
        lazyload: "off"
      }), jsx("div", {
        className: `${namespace$2}__section-text`,
        children: jsx("div", {
          className: `${namespace$2}__section-text-primary-title`,
          children: jsx(Typography, {
            size: 's',
            className: `${namespace$2}__section-text-primary-title-typography`,
            component: "h3",
            children: texts.primary_title
          })
        })
      })]
    })
  });
};
const IconChevron$1 = () => jsx("svg", {
  width: "7",
  height: "9",
  viewBox: "0 0 7 9",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: jsx("path", {
    // eslint-disable-next-line max-len
    d: "M0.950035 0.900286L4.54642 4.49667L0.946289 8.09681L1.79482 8.94534L6.24348 4.49667L1.79856 0.0517578L0.950035 0.900286Z",
    fill: "#3483FA"
  })
});
const namespace$1 = 'hero-bot';
const HeroBot = props => {
  const {
    items
  } = props;
  const [{
    event_tracking: {
      click
    },
    content: {
      is_verified_store: isVerifiedStore,
      texts
    }
  }] = items;
  const [url] = click;
  return jsxs("div", {
    className: `${namespace$1}`,
    children: [jsx("a", {
      href: url.url,
      children: jsxs("div", {
        className: `${namespace$1}__text-cta`,
        children: [isVerifiedStore && jsx(VerifiedStoreIcon, {
          size: 10
        }), jsx(Typography, {
          className: `${namespace$1}__text-cta-typography`,
          size: 'xs',
          color: "link",
          children: texts.cta
        }), jsx("div", {
          className: `${namespace$1}__text-cta-chevron`,
          children: jsx(IconChevron$1, {})
        })]
      })
    }), jsx("div", {
      className: `${namespace$1}__text-promoted`,
      children: jsx(Typography, {
        className: `${namespace$1}__text-promoted-typography`,
        color: "secondary",
        size: 'xs',
        component: "h2",
        children: texts.promoted
      })
    })]
  });
};
const IconChevron = () => jsx("svg", {
  width: "7",
  height: "9",
  viewBox: "0 0 7 9",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: jsx("path", {
    // eslint-disable-next-line max-len
    d: "M0.950035 0.900286L4.54642 4.49667L0.946289 8.09681L1.79482 8.94534L6.24348 4.49667L1.79856 0.0517578L0.950035 0.900286Z",
    fill: "#3483FA"
  })
});
const namespace = 'hero';
const Hero = props => {
  var _texts$alt_logo2;
  const {
    items,
    isMobile,
    lowEnd
  } = props;
  const [{
    event_tracking: {
      click
    },
    content: {
      is_verified_store: isVerifiedStore,
      images,
      texts
    },
    template: {
      tag
    }
  }] = items;
  const [url] = click;
  const mobileSize = {
    width: 80,
    height: 80
  };
  const desktopSize = tag === 'brand-ads-vertical' ? {
    width: 138,
    height: 138
  } : {
    width: 140,
    height: 140
  };
  return jsx("a", {
    href: url.url,
    children: jsxs("div", {
      className: `${namespace}`,
      children: [jsx("div", {
        className: `${namespace}__left`,
        children: jsx(Image, _objectSpread({
          preload: true,
          src: images.primary_logo,
          alt: (_texts$alt_logo2 = texts.alt_logo) !== null && _texts$alt_logo2 !== void 0 ? _texts$alt_logo2 : '',
          lowEnd: lowEnd,
          lazyload: "off"
        }, isMobile ? mobileSize : desktopSize))
      }), jsx("div", {
        className: `${namespace}__right`,
        children: jsxs("div", {
          className: `${namespace}__right-section-text`,
          children: [jsx(Typography, {
            className: `${namespace}__right-section-text-promoted-typography`,
            color: "secondary",
            size: isMobile ? 'xs' : 's',
            component: "h2",
            children: texts.promoted
          }), jsx("div", {
            className: `${namespace}__right-section-text-primary-title`,
            children: jsx(Typography, {
              size: isMobile ? 's' : 'l',
              className: `${namespace}__right-section-text-primary-title-typography`,
              component: "h3",
              children: texts.primary_title
            })
          }), jsxs("div", {
            className: `${namespace}__right-section-text-cta`,
            children: [isVerifiedStore && jsx(VerifiedStoreIcon, {
              size: isMobile ? 10 : 14
            }), jsx(Typography, {
              className: `${namespace}__right-section-text-cta-typography`,
              size: 'xs',
              color: "link",
              children: texts.cta
            }), jsx("div", {
              className: `${namespace}__right-section-text-cta-chevron`,
              children: jsx(IconChevron, {})
            })]
          })]
        })
      })]
    })
  });
};
const BrandWrapperMobile = props => {
  const {
    content,
    items,
    IconFactory,
    hasOverlay,
    lowEnd,
    tag
  } = props;
  const namespace = tag === 'brand-ads-vertical' ? 'brand-wrapper-mobile-old' : 'brand-wrapper-mobile-new';
  return jsx(Card, {
    paddingSize: "0",
    className: namespace,
    children: jsxs(CardContent, {
      children: [jsx("div", {
        className: `${namespace}__container-top`,
        children: tag === 'brand-ads-vertical' ? jsx(Hero, _objectSpread(_objectSpread({}, content), {}, {
          isMobile: true,
          lowEnd: lowEnd
        })) : jsx(HeroTop, _objectSpread(_objectSpread({}, content), {}, {
          lowEnd: lowEnd
        }))
      }), jsx(Carousel, {
        items: items,
        IconFactory: IconFactory,
        hasOverlay: hasOverlay !== null && hasOverlay !== void 0 ? hasOverlay : true
      }), tag !== 'brand-ads-vertical' && jsx("div", {
        className: `${namespace}__container-bot`,
        children: jsx(HeroBot, _objectSpread({}, content))
      })]
    })
  });
};
BrandWrapperMobile.displayName = 'BrandWrapperMobile';
const Grid = props => {
  const {
    tag,
    items
  } = props;
  const namespace = tag === 'brand-ads-vertical' ? 'grid-old' : 'grid-new';
  return jsx("div", {
    className: namespace,
    children: items.map(item => jsxs("a", {
      href: item.url,
      children: [jsxs("div", {
        className: `${namespace}__container-img`,
        children: [jsx(Image, {
          preload: true,
          className: `${namespace}__image`,
          src: item.image.src,
          alt: "",
          lazyload: "off",
          width: 134,
          height: 134
        }, "image"), jsx("div", {
          className: `${namespace}__dimmer`
        })]
      }), jsx(Typography, {
        size: "xs",
        color: "primary",
        component: "p",
        className: `${namespace}__title`,
        children: item.title
      })]
    }, item.id))
  });
};
const BrandWrapperDesktop = props => {
  const {
    content,
    items,
    lowEnd,
    tag
  } = props;
  const namespace = tag === 'brand-ads-vertical' ? 'brand-wrapper-desktop-old' : 'brand-wrapper-desktop-new';
  return jsx(Card, {
    paddingSize: "8",
    className: namespace,
    children: jsxs(CardContent, {
      className: `${namespace}__container`,
      children: [jsx("div", {
        className: `${namespace}__container-left`,
        children: jsx(Hero, _objectSpread(_objectSpread({}, content), {}, {
          lowEnd: lowEnd
        }))
      }), jsx("div", {
        className: `${namespace}__container-right`,
        children: jsx(Grid, {
          tag: tag,
          items: items
        })
      })]
    })
  });
};
BrandWrapperDesktop.displayName = 'BrandWrapperDesktop';

/* eslint-disable security/detect-unsafe-regex */
const saniticePrice = price => {
  const thousandSeparator = price.currency_id === 'MXN' ? ',' : '.';
  const [amount, cents] = String(price.amount).split('.');
  const fraction = amount.replace(/\B(?=(\d{3})+(?!\d))/g, thousandSeparator);
  return {
    currency_id: price.currency_id,
    symbol: price.symbol,
    decimal_separator: price.decimal_separator,
    fraction,
    cents
  };
};
const saniticeShippingPromise = item => {
  var _item$shipping, _item$shipping2;
  const shippingPromise = item.promise && !item.shipping ? {
    fullfilment: item.promise.fulfillment,
    promise: {
      text: item.promise.text,
      highlight: item.promise.color === '#FFFFFF'
    }
  } : {
    text: (_item$shipping = item.shipping) === null || _item$shipping === void 0 ? void 0 : _item$shipping.text,
    fullfilment: (_item$shipping2 = item.shipping) === null || _item$shipping2 === void 0 ? void 0 : _item$shipping2.fulfillment
  };
  return shippingPromise;
};
const saniticeIcon = icon_id => {
  const iconMapping = {
    melichoice_icon: 'meli_icon'
  };
  if (icon_id && iconMapping[icon_id]) {
    return iconMapping[icon_id];
  }
  return 'black_friday_icon';
};
const saniticeItems = (items, isMobile) => items.map(item => {
  var _item$price;
  return {
    className: isMobile && item.title && !item.price && !item.shipping && !item.dod ? 'brand-item-only-title' : 'brand-item',
    lazyLoad: false,
    priceSizeOverride: {
      price: isMobile ? 18 : 20,
      discount: 12
    },
    image: {
      size: '80px',
      src: item.picture
    },
    id: item.id,
    url: item.event_tracking.click[0].url,
    title: item.title,
    price: item.price && saniticePrice(item.price),
    shipping: (item.shipping || item.promise) && saniticeShippingPromise(item),
    discount: ((_item$price = item.price) === null || _item$price === void 0 ? void 0 : _item$price.discount_label) && item.price.discount_label,
    highlight_deal: item.dod && {
      label: {
        background: item.dod.background,
        size: 10,
        text: item.dod.text
      },
      icon: {
        id: item.dod.icon_id && saniticeIcon(item.dod.icon_id)
      }
    }
  };
});
const validateBaseProps = content => {
  var _content$items;
  if ((content === null || content === void 0 || (_content$items = content.items) === null || _content$items === void 0 ? void 0 : _content$items.length) > 0) {
    var _item$event_tracking, _item$event_tracking2;
    const [item] = content.items;
    if (item.content && ((_item$event_tracking = item.event_tracking) === null || _item$event_tracking === void 0 || (_item$event_tracking = _item$event_tracking.click) === null || _item$event_tracking === void 0 ? void 0 : _item$event_tracking.length) > 0 && ((_item$event_tracking2 = item.event_tracking) === null || _item$event_tracking2 === void 0 || (_item$event_tracking2 = _item$event_tracking2.print) === null || _item$event_tracking2 === void 0 ? void 0 : _item$event_tracking2.length) > 0) {
      const [{
        url: heroUrl
      }] = item.event_tracking.click;
      const [{
        url: printUrl
      }] = item.event_tracking.print;
      const {
        images,
        texts,
        marketplace_items: marketplaceItems
      } = item.content;
      return !(images && texts && heroUrl && printUrl && (marketplaceItems === null || marketplaceItems === void 0 ? void 0 : marketplaceItems.length) > 0);
    }
  }
  return true;
};
const isContentWithFastLoading = content => 'fast_loading' in content;
const modifiedContent = content => isContentWithFastLoading(content) ? {
  items: content.fast_loading.items
} : content;
const VIEWABILITY_ENABLED = 'viewability-enabled';
const VIEWABILITY_BREAKING_CHANGES_VERSION = '1.0.0';
const isViewabilityLegacy = viewability => viewability && (viewability === null || viewability === void 0 ? void 0 : viewability.version) !== VIEWABILITY_BREAKING_CHANGES_VERSION;
const isViewabilityLoaded = viewability => viewability && (viewability === null || viewability === void 0 ? void 0 : viewability.getNonceToken()) !== '';
const useViewability = (ref, viewUrl, isPreview) => {
  const startViewabilitySession = () => {
    var _window$viewability;
    const session = (_window$viewability = window.viewability) === null || _window$viewability === void 0 ? void 0 : _window$viewability.addSession();
    session === null || session === void 0 || session.setMeliVaTrackUrl(viewUrl);
    session === null || session === void 0 || session.start(ref === null || ref === void 0 ? void 0 : ref.current);
  };
  useEffect(() => {
    if (isPreview || !viewUrl || !ref) {
      return () => null;
    }
    if (isViewabilityLegacy(window.viewability)) {
      var _window$viewability2;
      (_window$viewability2 = window.viewability) === null || _window$viewability2 === void 0 || _window$viewability2.addSession(ref.current, viewUrl);
      return () => null;
    }
    if (isViewabilityLoaded(window.viewability)) {
      startViewabilitySession();
      return () => null;
    }
    window.addEventListener(VIEWABILITY_ENABLED, startViewabilitySession);
    return () => {
      window.removeEventListener(VIEWABILITY_ENABLED, startViewabilitySession);
    };
  }, [ref, viewUrl, isPreview]);
};
const WrapperBase = props => {
  var _ref;
  const {
    content,
    isMobile,
    IconFactory,
    hasOverlay,
    lowEnd
  } = props;
  const newContent = modifiedContent(content);
  if (validateBaseProps(newContent)) {
    return null;
  }
  const ref = useRef(null);
  const [{
    content: itemContent,
    event_tracking: {
      print,
      view
    },
    template: {
      tag
    }
  }] = newContent.items;
  const [{
    url: printUrl
  }] = print;
  const viewUrl = view ? (_ref = [...view]) === null || _ref === void 0 || (_ref = _ref.shift()) === null || _ref === void 0 ? void 0 : _ref.url : null;
  const Component = isMobile ? BrandWrapperMobile : BrandWrapperDesktop;
  useViewability(ref, viewUrl);
  return jsxs("div", {
    ref: ref,
    children: [jsx(Component, {
      items: saniticeItems(itemContent.marketplace_items, isMobile),
      content: newContent,
      IconFactory: IconFactory,
      hasOverlay: hasOverlay,
      lowEnd: lowEnd,
      tag: tag
    }), printUrl && jsx(ScriptPrint, {
      url: printUrl
    })]
  });
};
export { WrapperBase };
